import React, { useRef, useEffect } from 'react'
import * as tf from '@tensorflow/tfjs'
import * as handpose from '@tensorflow-models/handpose'
import Webcam from 'react-webcam'
import { drawHand } from './utilities'

import { up, down, leftDirection, rightDirection } from './Gestures'

import * as fp from 'fingerpose'
function GestureRecognition({ isLoading, setIsLoading }) {
  const webcamRef = useRef(null)
  const canvasRef = useRef(null)

  ///////// NEW STUFF ADDED STATE HOOK
  useEffect(() => {
    console.log('here')
    let id
    const runHandpose = async () => {
      const net = await handpose.load()
      console.log('Handpose model loaded.')
      setIsLoading(false)
      //  Loop and detect hands
      id = setInterval(() => {
        detect(net)
      }, 1000)
    }
    runHandpose()
    return () => clearInterval(id)
  }, [])
  // useEffect(() => console.log(emoji), [emoji]);
  let isKeyDown = false
  const detect = async (net) => {
    // Check data is available
    if (
      typeof webcamRef.current !== 'undefined' &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // Get Video Properties
      const video = webcamRef.current.video
      const videoWidth = webcamRef.current.video.videoWidth
      const videoHeight = webcamRef.current.video.videoHeight

      // Set video width
      webcamRef.current.video.width = videoWidth
      webcamRef.current.video.height = videoHeight

      // Set canvas height and width
      canvasRef.current.width = videoWidth
      canvasRef.current.height = videoHeight

      // Make Detections
      const hand = await net.estimateHands(video)
      // console.log(hand)

      ///////// NEW STUFF ADDED GESTURE HANDLING

      if (hand.length > 0) {
        const GE = new fp.GestureEstimator([
          up,
          down,
          leftDirection,
          rightDirection,
        ])
        const gesture = await GE.estimate(hand[0].landmarks, 4)
        if (gesture.gestures !== undefined && gesture.gestures.length > 0) {
          const confidence = gesture.gestures.map(
            (prediction) => prediction.score
          )
          const maxConfidence = confidence.indexOf(
            Math.max.apply(null, confidence)
          )
          console.log(gesture.gestures, confidence)
          console.log(gesture.gestures[maxConfidence]?.name)
          const generateEvent = (key, which, code) => {
            return {
              key: key,
              keyCode: which,
              which: which,
              code: code,
              location: 0,
              altKey: false,
              ctrlKey: false,
              metaKey: false,
              shiftKey: false,
              repeat: false,
            }
          }
          const eventdown1 = new KeyboardEvent(
            'keydown',
            generateEvent('w', 87, 'KeyW')
          )
          const eventdown2 = new KeyboardEvent(
            'keydown',
            generateEvent('a', 65, 'KeyA')
          )

          const eventdown3 = new KeyboardEvent(
            'keydown',
            generateEvent('s', 83, 'KeyS')
          )

          const eventdown4 = new KeyboardEvent(
            'keydown',
            generateEvent('d', 68, 'KeyD')
          )
          let variable = gesture.gestures[maxConfidence]?.name
          switch (variable) {
            case 'up':
              document.dispatchEvent(eventdown1)
              isKeyDown = true
              break
            case 'down':
              document.dispatchEvent(eventdown3)
              isKeyDown = true
              break
            case 'left':
              document.dispatchEvent(eventdown2)
              isKeyDown = true
              break
            case 'right':
              document.dispatchEvent(eventdown4)
              isKeyDown = true
              break
            default:
              console.log('default')
              break
          }
        }
      } else if (isKeyDown) {
        console.log('else')
        const generateEvent = (key, which, code) => {
          return {
            key: key,
            keyCode: which,
            which: which,
            code: code,
            location: 0,
            altKey: false,
            ctrlKey: false,
            metaKey: false,
            shiftKey: false,
            repeat: false,
          }
        }
        const eventup1 = new KeyboardEvent(
          'keyup',
          generateEvent('w', 87, 'KeyW')
        )
        const eventup2 = new KeyboardEvent(
          'keyup',
          generateEvent('a', 65, 'KeyA')
        )

        const eventup3 = new KeyboardEvent(
          'keyup',
          generateEvent('s', 83, 'KeyS')
        )

        const eventup4 = new KeyboardEvent(
          'keyup',
          generateEvent('d', 68, 'KeyD')
        )

        document.dispatchEvent(eventup1)
        document.dispatchEvent(eventup2)
        document.dispatchEvent(eventup3)
        document.dispatchEvent(eventup4)
        isKeyDown = false
      }
      const ctx = canvasRef.current.getContext('2d')
      ctx.translate(canvasRef.current.width, 0)
      ctx.scale(-1, 1)
      drawHand(hand, ctx)
      ctx.scale(-1, 1)
      ctx.translate(-canvasRef.current.width, 0)
    }
  }

  return !isLoading ? (
    <div className="App">
      <header className="App-header">
        <Webcam
          ref={webcamRef}
          mirrored
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            textAlign: 'center',
            zIndex: 9,
            width: 320,
            height: 240,
          }}
        />

        <canvas
          ref={canvasRef}
          style={{
            position: 'absolute',
            right: 0,
            left: 'auto',
            top: 0,
            textAlign: 'center',
            zIndex: 9,
            width: 320,
            height: 240,
          }}
        />
      </header>
    </div>
  ) : null
}

export default GestureRecognition
